import React, { Fragment, useEffect, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { getUserRole, showAlert } from "../../../Services/Shared.service";
import { Alert} from "reactstrap";
// import { Admin } from "../../../Constant";
import {Admin, OnboardingAgent } from "../../../Data/SideMenu/RouteMapping";
import AttendanceModal from "../DriverAttendance/AttendanceModal";
import { Button } from "@mui/material";
import { GetDriverAttendanceList } from "../../../Services/Driver.service";
import { MaterialReactTable } from "material-react-table";
import { CalendarViewFunctions } from "../../Rates/Components/CalendarViewFunctions";
import { endOfMonth, startOfMonth } from "date-fns";
import DriverAttendanceCalender from "../DriverAttendance/DriverAttendanceCalender";
const DriverAttendance = ({ driverId }) => {
  const userRole = getUserRole()

  const [attendanceModal,SetAttendanceModal] = useState(false);
  const toggleAttendanceModal = () => SetAttendanceModal(!attendanceModal);
  const [loader, setLoader] = useState(false);

  // ------calender
  const [calendarData, setCalendarData] = useState([])
  const [tableHeaders,setTableHeaders] = useState([])
  const [tableData, setTableData] = useState([]);
  const calendarViewFunctions = new CalendarViewFunctions()

 useEffect(() => {
  fetchData()

 }, [driverId])


   let fetchData=()=>{
    if(driverId){
      setLoader(true);
      let obj={
        id:driverId
      }
      GetDriverAttendanceList(obj).then(async(res)=>{

        setCalendarData(await calendarViewFunctions.getAttendanceCalendarData(res.data, false, startOfMonth(new Date()),endOfMonth(new Date())))
        setTableHeaders(await calendarViewFunctions.getTableHeaderAttendance(startOfMonth(new Date()), endOfMonth(new Date())))
        setTableData(res.data)
        console.log("attendanceERr",await calendarViewFunctions.getAttendanceCalendarData(res.data, false, startOfMonth(new Date()),endOfMonth(new Date())))
        disableLoaders();
      }).catch((err)=>{
        disableLoaders();
        console.log(err)
        showAlert("error", err.response?.data?.message
          ? err.response.data.message : "Something went wrong");
      })
    }
   }
   const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
};

  return (
    <Fragment>
      <Breadcrumbs 
       parent="Configuration"
       subParent="Inventory"
       mainTitle="Cabs"
      span2={
        userRole.some(
          (element) => element == Admin || element == OnboardingAgent
        ) ? (
          <Button
          sx={{
            display: "flex",
            padding: "5px 20px",
            margin: "0 3px",
            justifyContent: "center",
            alignItems: "center",
            color: "#000",
            backgroundColor: "#eaeaea",
          }}
            
            onClick={() => toggleAttendanceModal()}
          >
            Apply Leave
          </Button>
        ) : null
      }
      />


     
       <DriverAttendanceCalender
        attendanceData={tableData}
        calendarData={calendarData}
        setCalendarData={setCalendarData}
        tableHeaders={tableHeaders}
        setTableHeaders={setTableHeaders}
        loader={loader}
        />     





      <AttendanceModal
       Large={attendanceModal} 
       title="Leave date"
       LargeModaltoggle={toggleAttendanceModal}
      driverObj={driverId}
      fetchData={fetchData} 
      />
    </Fragment>
  );
};

export default DriverAttendance;
